// extracted by mini-css-extract-plugin
export default {"pageWrap":"Rc-z","fullWidth":"Sc-z","heading":"Tc-z","fullBleed":"Uc-z","hidden":"Vc-z"};